<template>
  <div class="vue__payment-hdp-direct">
    <div class="field">
      <p>Die Online-Bankzahlung wird über eine externe Seite initiiert, auf der Sie Ihre Bank auswählen.</p>
      <button
        ref="elementRef"
        v-on:click="submit"
        id="direct"
        class="unzerUI primary button fluid"
      >Mit Direktüberweisung kostenpflichtig bestellen</button>
    </div>
  </div>
</template>

<script>
import createHeidelpayInstance from "../../lib/create-heidelpay-instance";
import useElementDisabler from "../compositions/use-element-disabler";

export default {
  setup(props, { emit }) {
    // Creating a credit card instance
    const heidelpayInstance = createHeidelpayInstance();
    const Direct = heidelpayInstance.OpenBanking();

    const { elementRef, elementControl } = useElementDisabler();

    const submit = async () => {
      try {
        elementControl(false);
        const result = await Direct.createResource();
        emit("pay", result, elementControl);
      } catch (error) {
        console.error("Error while submitting heidelpay form", error);
        elementControl(true);
      }
    };

    return {
      // methods:
      submit,

      // element refs:
      elementRef,
    };
  },
};
</script>
